import styles from './commentMobile.module.css';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material";
import { ArrowLeft, Edit, MoreVertical, Plus, Search, Trash2, X } from "react-feather";
import { Dropdown } from "react-bootstrap";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import axios from 'axios';
import { Controller, useForm } from "react-hook-form";
import { useAuth0 } from "@auth0/auth0-react";
import { useState } from "react";
import { AddLogCallAPI } from "../../../../components/AddLogs";
import { toast } from 'react-smart-toaster';
import { useEffect } from "react";
import dayjs from "dayjs";

const schemaNote = yup.object().shape({
  note: yup.string().required('This field is Required').max(400, 'Notes cannot be more than 400 characters'),
});

const CommentMobile = ({ isPanelOpen, onToggle, notes, requestData, setRequestData, setSnackbarOpen, setSnackbarMsg, setLoading }) => {
  const [openContractor, setOpenContractor] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [noteId, setNoteId] = useState(0);
  const [charsLeft, setCharsLeft] = useState(400);
  const [noteList, setNoteList] = useState([]);
  const [filteredNoteList, setFilteredNoteList] = useState([]);
  const [filterData, setFilterData] = useState({ searchKey: "" });
  const [noteData, setNoteData] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const { handleSubmit, errors, setValue, control } = useForm({
    resolver: yupResolver(schemaNote),
    defaultValues: {
      note: ''
    }
  });

  useEffect(() => {
    if (noteData) {
      setNoteId(noteData?.id);
      setValue('note', noteData?.note);
      setCharsLeft(400 - noteData?.note?.length);
    } else {
      setValue('note', '');
    }
  }, [noteData, setValue]);

  useEffect(() => {
    if (notes) {
      setNoteList(notes);
    }
  }, [notes]);

  useEffect(() => {
    let filteredList = noteList;

    if (filterData.searchKey !== "") {
      let inputVal = filterData.searchKey;
      inputVal = inputVal.toLowerCase();
      filteredList = filteredList.filter((item) => item.note.toLowerCase().includes(inputVal));
    }

    setFilteredNoteList(filteredList);
  }, [noteList, filterData]);

  const delConfirm = async () => {
    setOpenDeleteModal(false);
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    return axios.delete(process.env.REACT_APP_CASE_API_URL + 'v1/maintenance-requests/' + requestData?.id + '/notes/' + noteData?.id, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then(response => {
      setLoading(false);

      setSnackbarOpen(true);
      setSnackbarMsg(response.data.message);

      setRequestData(prev => {
        let notes = prev?.notes?.filter(i => i?.id !== noteData?.id);
        return { ...prev, notes: notes };
      });

      let logData = {
        'title': 'Maintenance request  comment is deleted',
        'description': [
          'Name: ' + requestData?.title,
          'Request number: ' + requestData?.request_no,
          'Property: ' + requestData?.property_name,
          'Apartment: ' + requestData?.apt_name,
          'Tenant: ' + requestData?.tenant_name,
          'Comment: ' + noteData?.note,
        ]
      }
      AddLogCallAPI(logData, token);

      setNoteData(null);
    }).catch(error => {
      if (typeof error.response !== 'undefined')
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }



  const handleClickOpenContractor = () => {
    setOpenContractor(true);
  };
  const handleCloseContractor = () => {
    setOpenContractor(false);
  };

  const onSubmit = async (data) => {
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    if (noteId) {
      return axios.put(process.env.REACT_APP_CASE_API_URL + 'v1/maintenance-requests/' + requestData?.id + '/notes/' + noteId, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then(response => {
        setLoading(false);

        setSnackbarOpen(true);
        setSnackbarMsg(response.data.message);

        handleCloseContractor();
        setNoteData(null);

        setRequestData(prev => {
          let notes = prev?.notes?.map(i => {
            if (i?.id === noteId)
              return { ...i, note: response.data.data.note };
            return i;
          });
          return { ...prev, notes: notes };
        });

        let logData = {
          'title': 'Maintenance request  note is updated',
          'description': [
            'Name: ' + requestData?.title,
            'Request number: ' + requestData?.request_no,
            'Property: ' + requestData?.property_name,
            'Apartment: ' + requestData?.apt_name,
            'Tenant: ' + requestData?.tenant_name,
            'Comment: ' + response.data.data?.note,
          ]
        }
        AddLogCallAPI(logData, token);

      }).catch(error => {
        if (typeof error.response !== 'undefined')
          toast.error(error.response.data.message);
        setLoading(false);
      });
    } else {
      return axios.post(process.env.REACT_APP_CASE_API_URL + 'v1/maintenance-requests/' + requestData?.id + '/notes', data, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then(response => {
        setLoading(false);

        setSnackbarOpen(true);
        setSnackbarMsg(response.data.message);

        handleCloseContractor();
        setNoteData(null);

        setRequestData(prev => {
          let notes = [response.data.data].concat(prev?.notes)
          return { ...prev, notes: notes };
        });

        let logData = {
          'title': 'Maintenance request new note is created',
          'description': [
            'Name: ' + requestData?.title,
            'Request number: ' + requestData?.request_no,
            'Property: ' + requestData?.property_name,
            'Apartment: ' + requestData?.apt_name,
            'Tenant: ' + requestData?.tenant_name,
            'Comment: ' + response.data.data?.note,
          ]
        }
        AddLogCallAPI(logData, token);
      }).catch(error => {
        if (typeof error.response !== 'undefined')
          toast.error(error.response.data.message);
        setLoading(false);
      });
    }
  }

  return (
    <>
      <div className={`${styles.AccordionList}`}>
        <div className={`${styles.AccordionListHead} ${isPanelOpen ? styles.Open : ""}`} onClick={() => onToggle("four")}>
          <p className={`${styles.Title}`}>Comments</p>
          <img src="/static/img/downTriangle.svg" alt="" />
        </div>
        <div className={`${styles.AccordionListBody} ${isPanelOpen ? styles.Open : ""}`}>
          {filteredNoteList?.length > 0 && <div className={`${styles.NotesSearchArea}`}>
            <div className={`${styles.NotesSearchMain}`}>
              <Search />
              <input type="text" placeholder="Search" className={`${styles.searchInput}`} onChange={(e) => setFilterData(prev => { return { ...prev, searchKey: e.target.value } })} />
            </div>
            <button className={`${styles.AddNoteBu}`} onClick={(e) => { handleClickOpenContractor(); setNoteData(null); }}><Plus /></button>
          </div>}
          <div className={`${styles.TabBodySec}`}>
            {filteredNoteList?.map(item => {
              return (<div className={`${styles.WorkOrderCard}`}>
                <div className={`${styles.CardAvatar}`}><p>{item?.user_initial}</p></div>
                <div className={`${styles.CardDetails}`}>
                  <p className={`${styles.Title}`}>{item?.user_name}</p>
                  <p className={`${styles.SubTitle}`}>{item.role} @{requestData?.property_name}</p>
                  <p className={`${styles.SubTitle}`}>{dayjs(item?.created_at).fromNow()}</p>
                  <p className={`${styles.Description}`}>{item.note}</p>
                  <div className={`${styles.WorkOrderActionBU}`}>
                    <Dropdown>
                      <Dropdown.Toggle id="dropdown-basic" className={`${styles.FilesUpCardDDAction}`}>
                        <MoreVertical />
                      </Dropdown.Toggle>

                      <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                        <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { handleClickOpenContractor(); setNoteData(item); }}>
                          <Edit /> Edit
                        </Dropdown.Item>
                        <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setOpenDeleteModal(true); setNoteData(item); }}>
                          <Trash2 /> Delete
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>)
            })}

            {filteredNoteList?.length === 0 && <div className={`${styles.NoDataMainWithBU}`}>
              <div>
                <div className={`${styles.NoDataIMGWithBU}`}><img src="/static/img/no-comment.png" alt="" /></div>
                <p className={`${styles.NoDataTextWithBU}`}>Quiet here...</p>
                <p className={`${styles.NoDataTextSubWithBU}`}>Be the first to leave a comment!</p>
                <button className={`${styles.AddLeaseBUWithBU}`} onClick={(e) => { handleClickOpenContractor(); setNoteData(null); }}><Plus /> Add Comment</button>
              </div>
            </div>}

          </div>
        </div>
      </div>

      <Dialog
        open={openContractor}
        fullWidth
        maxWidth="xs"
        onClose={handleCloseContractor}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp MobileForm"
      >
        <DialogTitle id="alert-dialog-title">
          <button className={`${styles.BackAddBU}`} onClick={(e) => { handleCloseContractor(); setNoteData(null); }}><ArrowLeft /></button>
          {noteId ? 'Update Note' : 'Add Note'}
          <button onClick={(e) => { handleCloseContractor(); setNoteData(null); }}>
            <X />
          </button>
        </DialogTitle>
        <DialogContent className={`${styles.RequestBodyPop}`}>
          <div className={`${styles.ModalFormGroup}`}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className={`${styles.PopFormGroup}`}>
                <div className={`${styles.FormGroupFull} FormGroup`}>
                  <Controller
                    name={`note`}
                    control={control}
                    render={(field) => (
                      <TextField
                        {...field}
                        value={field?.value ? field?.value : ''}
                        onChange={(e) => {
                          field.onChange(e);
                          setCharsLeft(400 - e.target.value.length);
                        }}
                        id="outlined-basic"
                        label="Comments"
                        variant="outlined"
                        multiline
                        rows={6}
                      />
                    )}
                  />
                  <p className={`${styles.RemainingText}`}>{charsLeft} {charsLeft > 1 ? "characters" : "character"} remaining</p>
                  {errors.note && <p className={`${styles.ErrorM}`}>{errors.note.message}</p>}
                </div>
              </div>
              <div className={`${styles.ButtonAction}`}>
                <Button onClick={handleCloseContractor} className="CancelPopupBU">Cancel</Button>
                <Button type="submit" className="SubmitPopupBU"> {noteId ? 'Update' : 'Add'}</Button>
              </div>
            </form>
          </div>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openDeleteModal}
        fullWidth
        maxWidth="sm"
        onClose={(e) => setOpenDeleteModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp"
      >
        <DialogTitle id="alert-dialog-title">Are you sure you want to delete the note?<button onClick={(e) => setOpenDeleteModal(false)}><X /></button></DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div className="ModalFormGroup">
              <label className="PopupBodyText">The note will be removed immediately.You can't undo this action.</label>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="CancelPopupBU" onClick={(e) => delConfirm()}>Delete</Button>
          <Button className="SubmitPopupBU" onClick={(e) => setOpenDeleteModal(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default CommentMobile;
